module.exports = __webpack_public_path__ + "img/symbol_8.47601963.png";